import {css} from 'lit';
import {smartphoneOnly, tablet} from '../../js/services/const';

export default css`
:host {
  --region-select-wrap-pt: 0;
  --region-container-margin: 2rem 0;
  display: block;
  padding-top: 1rem;
}

.region-container {
  background: var(--page-background);
}

:host([isdropdownonly="true"]) {
  background: transparent;
}

:host([isdropdownonly="false"]) {
  background: var(--page-background);
  margin-bottom: 3rem;
}

.region__select-wrap {
  display: block;
  flex-direction: column;
  padding-top: var(--region-select-wrap-pt);
}

.region__select-ic {
  display: flex;
  position: relative;
  width: 100%;
  /*max-width: 500px;*/
}

.region__select-ic::after {
  color: var(--text-highVisibility);
  pointer-events: none;
  font-family: 'icons';
  display: inline-block;
  content: '\\e90f';
  font-size: 1.6rem;
  top: 20%;
  right: 3rem;
  position: absolute;
  transform: rotate(90deg);
}

/* on hover the color of the dropdown arrow must change */
.region__select-ic:hover ::after,
.region__select-ic:focus ::after {
    color: var(--element-hover-color);
  }

/* hide arrow for select in ie11 */
.region__select::-ms-expand {
  display: none;
}

.region__select-ic:active::after,
.region__select-ic:focus::after {
  /* Can't use 'content: "\e608"'; the dropdown menu doesn't open in Firefox */
  transform: rotate(270deg);
}

.region__img {
  display: none;
}

:host([isDropdownOnly="true"]) .region-container {
  margin: var(--region-container-margin);
}

:host([isDropdownOnly="false"]) .region-container {
  display: flex;
  flex-direction: column;
  gap: 22px;
}

:host([isdropdownonly="true"]) .region__img-container {
  display: block;
  max-width: 100%;
  margin: 0 auto 1rem;
}

:host([isdropdownonly="true"]) .region__dropdown-img {
  /* To support IE11 we need to use proportion
  https://voormedia.com/blog/2012/11/responsive-background-images-with-fixed-or-fluid-aspect-ratios */
  padding-top: 56.17%;
  background-size: contain;
  background-position: center bottom;
  background-image: var(--region-bg);
  background-repeat: no-repeat;
  // background-image: var(--region-bg);
  // background-repeat: no-repeat;
  // background-position: center bottom;
  // background-size: contain;
  background-color: var(--identity-highVisibility);
  -webkit-mask-image: var(--region-bg);
  mask-image: var(--region-bg);
  mask-repeat: no-repeat;
  mask-size: contain;
  mask-position: center bottom;
  -webkit-mask-repeat: no-repeat;
  -webkit-mask-size: contain;
  -webkit-mask-position: center bottom;
}

:host([isdropdownonly="true"]) .region__img {
  display: block;
}

:host([isdropdownonly="true"]) .region__select-ic-wrap {
  display: flex;
  justify-content: center;
}

:host([isdropdownonly="true"]) .region__select-ic::after {
    right: 1.2rem;
}

:host([isdropdownonly="true"]) .region__select-wrap {
  padding: 1rem 0 2rem;
  margin-bottom: 2.5rem;
  text-align: center;
}

@media (max-width: ${smartphoneOnly}px) {
  :host([isdropdownonly="true"]) .region-container {
    position: relative;
  }

  :host([isdropdownonly="true"]) .region__select-wrap {
    padding-top: 5rem;
  }

  :host([isdropdownonly="true"]) .region__img-container {
    padding: 0 1rem;
    background-color: var(--identity-lowVisibility);
  }
}

@media (min-width: ${tablet}px) {
  :host([isdropdownonly="true"]) .region-container {
    background: var(--identity-lowVisibility);
  }

  :host([isdropdownonly="true"]) .region__img-container {
    max-width: 350px;
    margin-bottom: 3rem;
  }

  :host([isdropdownonly="true"]) .region__select-ic-wrap {
    display: inline-block;
    width: 40%;
    margin-left: 2%;
    vertical-align: top;
  }

  :host([isdropdownonly="true"]) .region__select-ic {
    padding-right: 0;
    padding-left: 0;
  }
}
`;
